import { supabase } from '../client'

export async function deleteDiscordUser(id: number) {
  const { data, error } = await supabase.from('tfCustomerDiscordUser').delete().match({ id })
  return { data, error }
}
